module.exports = __webpack_public_path__ + "img/20220411_130144.f4c776a9.jpg";